import React from 'react';
import { Col, Row } from 'reactstrap';
import { Action, HierarchicalEntityCategory } from '@anodot-cost/rbac-client';
import Delete from 'mdi-react/TrashCanOutlineIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import SendIcon from 'mdi-react/SendIcon';
import LinkIconButton from 'shared/components/buttons/LinkIconButton';
import ReadOnlyDisplayWrapper from 'shared/components/ReadOnlyDisplayWrapper';
import toast from 'shared/components/andtComponents/Toast';
import { SuccessNotificationsLabels } from 'shared/constants/notificationsConstants';
import { useRootStore } from '~/app/contexts/RootStoreContext.jsx';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';

const linkStyle = {
  display: 'inline-block',
  position: 'relative',
  zIndex: 1,
  padding: '1em',
  margin: '-1em',
};
const buttonContainerStyle = {
  display: 'flex',
  flexFlow: 'row',
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
};

const UserActions = (props) => {
  const { row, updateReportHandler, sendReportHandler, deleteHandler, shareHandler } = props;
  const { appStore } = useRootStore();
  return (
    <i>
      <Row>
        <Col>
          <ReadOnlyDisplayWrapper isHide={false} category={HierarchicalEntityCategory.Reports} action={Action.Update}>
            <LinkIconButton containerStyle={buttonContainerStyle}>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  deleteHandler(row.uuid);
                }}
              />
              <Delete />
            </LinkIconButton>
          </ReadOnlyDisplayWrapper>
        </Col>
        <Col>
          <ReadOnlyDisplayWrapper isHide={false} category={HierarchicalEntityCategory.Reports} action={Action.Update}>
            <LinkIconButton containerStyle={buttonContainerStyle}>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  updateReportHandler(row.uuid);
                }}
              />

              <PencilIcon />
            </LinkIconButton>
          </ReadOnlyDisplayWrapper>
        </Col>
        <Col>
          <LinkIconButton containerStyle={buttonContainerStyle}>
            <button
              style={{
                ...linkStyle,
                color: '#70bbfd',
              }}
              type="button"
              className="btn-no-style"
              onClick={() => {
                sendReportHandler(row.uuid);
                toast.success(SuccessNotificationsLabels.REPORT_SENT);
              }}
            />
            <SendIcon />
          </LinkIconButton>
        </Col>
        {appStore.isKeyCloakManagement && (
          <Col>
            <ReadOnlyDisplayWrapper isHide={false} category={HierarchicalEntityCategory.Reports} action={Action.Update}>
              <LinkIconButton containerStyle={buttonContainerStyle}>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    shareHandler(row.uuid);
                  }}
                />
                <GenerateIcon iconName={ICONS.share.name} style={{ width: 20, height: 20 }} />
              </LinkIconButton>
            </ReadOnlyDisplayWrapper>
          </Col>
        )}
      </Row>
    </i>
  );
};


export default UserActions;
